import React from 'react';
import PropTypes from 'prop-types';
import Button from 'src/components/button';

const propTypes = {
  acceptConnection: PropTypes.func.isRequired,
  displayName: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
};

const AcceptButton = ({acceptConnection, displayName, id}) => (
  <Button
    outline
    size="tiny"
    color="blue"
    margin={false}
    className="blue-outline connection-information-card-button"
    aria-label={`Connect to ${displayName}`}
    onClick={() => acceptConnection(id)}
  >
    Accept Connection
  </Button>
);

AcceptButton.propTypes = propTypes;

export default AcceptButton;
